export default "__VITE_ASSET__BzqSwDvv__"